<template>
  <b-container fluid>
    <b-row>
      <b-col cols="12">
        <b-overlay
          :show="isLoading"
          rounded="sm"
        >
          <b-card
            no-body
            class="shadow-sm pt-0 pl-0 pr-0 m-4 mb-0"
          >
            <b-navbar
              class="background-white"
              toggleable="lg"
            >
              <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
              <b-navbar-brand href="#">
                <strong style="color:#3b3e66">Tasks</strong>
              </b-navbar-brand>

              <b-collapse
                id="nav-collapse"
                is-nav
              >
                <b-navbar-nav class="ml-auto">
                  <b-nav-form>
                    <b-button
                      variant="outline-info"
                      size="sm"
                      class="mr-2"
                      @click="reloadTable"
                    >
                      <!-- <font-awesome-icon icon="sync" /> -->
                      Reload
                    </b-button>
                    <b-form-group>
                      <b-input-group size="sm">
                        <b-form-input
                          v-model="filter"
                          type="search"
                          id="filterInput"
                          placeholder="Type to Search"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            :disabled="!filter"
                            @click="filter = ''"
                          >Clear</b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-nav-form>
                </b-navbar-nav>
              </b-collapse>
            </b-navbar>
            <b-table
              class="main-table"
              hover
              striped
              sticky-header="calc(100vh - 295px)"
              ref="table"
              id="main-tasks-table"
              :busy.sync="isLoading"
              :fields="staticFields"
              :items="getOnboardingTableData"
              :filter="filter"
              :per-page="perPage"
              :current-page="currentPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              responsive="sm"
              selectable
              select-mode="single"
              @row-selected="onSelectRow"
              no-sort-reset
            >
              <template v-slot:cell(created_at)="data">
                <p>{{ createdAtDate(data.item.created_at) }}</p>
              </template>
              <template v-slot:cell(employee)="data">{{data.item.first_name+' '+data.item.last_name}}</template>
              <template v-slot:cell(task_title)="data">
                <p
                  v-if="data.item.form_type != 4"
                  class="link-text"
                  @click="setUserTaskUrl(data.item)"
                >
                  {{ data.item.task_title}}
                </p>
                <p v-else>{{ data.item.task_title}}</p>
              </template>
              <template v-slot:cell(assigned_to_user_id)="data">
                <b-avatar
                  v-if="data.item.assigned_to_contact_first_name && data.item.assigned_to_contact_last_name && data.item.assigned_to_contact_profile_img_url == null"
                  variant="success"
                  v-b-tooltip.hover.bottom="data.item.assigned_to_contact_first_name+' '+data.item.assigned_to_contact_last_name"
                >{{getAssignedUserName(data)}}</b-avatar>
                <b-avatar
                  v-else-if="data.item.assigned_to_user_id != '0' && data.item.assigned_to_contact_profile_img_url"
                  variant="info"
                  :src="data.item.assigned_to_contact_profile_img_url"
                ></b-avatar>
                <b-btn
                  size="sm"
                  v-else
                  @click="openAssignUserModal(data)"
                  variant="outline-warning"
                >Assign</b-btn>
              </template>
              <template v-slot:cell(task_status)="data">
                <b-badge
                  v-if="data.item.task_status == '0'"
                  variant="info"
                >Pending</b-badge>
                <b-badge
                  v-if="data.item.task_status == '1'"
                  variant="warning"
                >In Progress</b-badge>
                <b-badge
                  v-if="data.item.task_status == '2'"
                  variant="warning"
                >On hold</b-badge>
                <b-badge
                  v-if="data.item.task_status == '3'"
                  variant="dark"
                >Review</b-badge>
                <b-badge
                  v-if="data.item.task_status == '4'"
                  variant="success"
                >Complete</b-badge>
                <b-badge
                  v-if="data.item.task_status == '7'"
                  variant="success"
                >Approved</b-badge>
                <b-badge
                  v-if="data.item.task_status == '8'"
                  variant="danger"
                >On hold</b-badge>
              </template>
            </b-table>
            <template v-slot:footer>
              <b-row>
                <b-col cols="2">
                  <b-form-select
                    v-model="perPage"
                    id="perPageSelect"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
                </b-col>
                <b-col cols="6">
                  <p class="text-center">
                    Showing Result From
                    <b>{{fromRows}}</b> to
                    <b>{{toRows}}</b>
                  </p>
                </b-col>
                <b-col cols="4">
                  <b-pagination
                    class="float-right"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                    aria-controls="main-tasks-table"
                  ></b-pagination>
                </b-col>
              </b-row>
            </template>
          </b-card>
        </b-overlay>

        <b-modal
          hide-header-close
          no-close-on-backdrop
          no-close-on-esc
          title="Assign User"
          v-model="showAssignModal"
          size="ms"
        >
          <b-form-group>
            <label class="text-left">Select User</label>
            <v-select
              @input="setSelectedUserValue"
              label="user_full_name"
              v-model="selectedUser"
              :options="usersOptions"
            ></v-select>
          </b-form-group>
          <template v-slot:modal-footer>
            <b-button
              @click="closeAssignModal"
              variant="outline-danger"
            >Close</b-button>
            <b-button
              @click="assignUser"
              variant="outline-success"
            >Assign</b-button>
          </template>
        </b-modal>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { HTTP } from "../../utils/HTTP";
import moment from "moment";
import "moment/locale/es";
export default {
  name: "OnboardingPage",
  data () {
    return {
      itemsBreadcrumb: [
        {
          text: "Dashboard",
          href: "dashboard",
        },
        {
          text: "Tasks",
          href: "#",
          active: true,
        },
      ],
      showAssignModal: false,
      isLoading: false,
      totalRows: 0,
      fromRows: 0,
      toRows: 0,
      filter: null,
      perPage: 10,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      staticFields: [
        {
          key: "created_at",
          label: "Date Filed",
          sortable: true,
        },
        {
          key: "employee",
          label: "Employee",
          sortable: true,
        },
        {
          key: "task_title",
          label: "Task Title",
          sortable: true,
        },
        {
          key: "department",
          label: "Department",
          sortable: true,
        },
        {
          key: "assigned_to_user_id",
          label: "Reviewer",
          sortable: true,
        },
        {
          key: "task_status",
          label: "Status",
          sortable: true,
        },
      ],
      usersOptions: [],
      selectedUser: null,
      selectedUserValue: null,
      onboardingTaskId: null,
    };
  },
  computed: {
    rows () {
      return this.totalRows;
    },
  },
  mounted () {
    this.getUsersList();
  },
  methods: {
    createdAtDate ( value ) {
      moment.locale( "en" );
      return moment( value ).format( "DD/MM/YYYY" );
    },
    onSelectRow ( data ) {
      if ( data[0].id ) {
        if ( data[0].form_type != 4 ) {
          this.setUserTaskUrl( data[0] );
        } else {
          this.$refs.table.clearSelected();
        }
      }
    },
    setUserTaskUrl ( data ) {
      this.$store.state.selectedTaskType = "/tasks";
      localStorage.setItem( 'selected_task_type', this.$store.state.selectedTaskType );
      if (
        data.form_type == 1 ||
        data.form_type == 8 ||
        data.form_type == 10
      ) {
        localStorage.removeItem( "taskId" );
        localStorage.removeItem( "activeFormSchema" );
        localStorage.removeItem( "taskFormData" );
        localStorage.removeItem( "activeTaskStatus" );

        localStorage.setItem( "taskId", data.id );
        this.$router.push( "/emplyee-user-form/" + data.id + "/2" );
      } else if ( data.form_type == 3 ) {
        localStorage.removeItem( "taskId" );
        localStorage.removeItem( "activeFormSchema" );
        localStorage.removeItem( "taskFormData" );
        localStorage.removeItem( "activeTaskStatus" );

        localStorage.setItem( "taskId", data.id );
        this.$router.push( "/emplyee-training/" + data.id + "/2" );
      } else if (
        data.module_id == 11 ||
        data.module_id == 3
      ) {
        this.$store.state.selectedTaskType = 'Tasks';
        localStorage.setItem( 'selected_task_type', this.$store.state.selectedTaskType );
        this.$router.push( '/view-complaint-detail/' + data.onboarding_id );
      } else if (
        data.module_id == 2 ||
        data.module_id == 5
      ) {
        this.$store.state.selectedTaskType = 'Tasks';
        localStorage.setItem( 'selected_task_type', this.$store.state.selectedTaskType );
        this.$router.push( '/gifts-approval/' + data.onboarding_id + '/1' );
      }
    },
    getAssignedUserName ( data ) {
      let firstName = data.item.assigned_to_contact_first_name.toUpperCase();
      let lastName = data.item.assigned_to_contact_last_name.toUpperCase();
      let name = firstName.charAt( 0 ) + lastName.charAt( 0 );

      return name;
    },
    reloadTable () {
      this.$root.$emit( "bv::refresh::table", "main-tasks-table" );
    },
    openAssignUserModal ( data ) {
      this.onboardingTaskId = data.item.id;
      this.showAssignModal = true;
    },
    async getUsersList () {
      this.usersOptions = [];
      this.isLoading = true;
      try {
        let result = await HTTP( "get", "api/v1/user/list", null );
        this.usersOptions = result.data;
        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
    },
    setSelectedUserValue ( value ) {
      this.selectedUserValue = null;
      this.selectedUserValue = value.id;
    },
    async getOnboardingTableData () {
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + ( this.sortDesc == true ? "desc" : "asc" ),
        per_page: this.perPage,
        page: this.currentPage,
      };
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem( "accessToken" );
      let response = await HTTP( "post", "api/v1/onboarding/tasks", formData, {
        Authorization: token,
      } );
      try {
        this.isLoading = false;
        this.fromRows = response.data.from;
        this.toRows = response.data.to;
        this.totalRows = response.data.total;
        return response.data.data;
      } catch ( err ) {
        this.isLoading = false;
        return [err];
      } finally {
        this.isLoading = false;
      }
    },
    closeAssignModal () {
      this.showAssignModal = false;
      this.selectedUserValue = null;
      this.selectedUser = null;
    },
    async assignUser () {
      let formData = {
        assigned_to_user_id: this.selectedUserValue,
        user_id: localStorage.getItem( "userId" ),
      };
      try {
        await HTTP(
          "post",
          "api/v1/onboarding/assign/user/" + this.onboardingTaskId,
          formData
        );
        this.reloadTable();
        this.closeAssignModal();
      } catch ( err ) {
        return [err];
      }
    },
  },
};
</script>
<style scoped>
@import "../../assets/styles/theme1/tabs.css";
@import "../../assets/styles/theme1/timeline.css";
/* @import "../../assets/styles/theme1/card.css"; */
@import "../../assets/styles/theme1/badge.css";
</style>

<style>
.table-hover tbody tr:hover td {
  background-color: rgb(255, 251, 242) !important;
}
</style>
